import React from "react";
import ModulesSideNav from "./ModulesSideNav";

const ModulesLayout = ({ children, defaultCollapsed = false }) => {
  return (
    <div className="w-full max-w-[1800px] mx-auto px-4 md:px-6 py-4 md:py-6">
      <div className="flex flex-col md:flex-row gap-4 md:gap-6">
        <ModulesSideNav defaultCollapsed={defaultCollapsed} />
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
};

export default ModulesLayout;
